import { ALL_MK_EVENTS, INSTRUMENT_TYPE } from '../const'
import UIUtils from '../utils/UIUtils'
import BlastInfo from '../../../mock/data/BlastInfo'

const calibrateTimings = well => {
    const morphokinetics = well.inferenceData.morphokinetics

    if (morphokinetics) {
        for (const mkEvent of morphokinetics) {
            mkEvent.value = parseFloat(mkEvent.value.toFixed(2))
        }
    }

    const runs = well.runs

    for (const runKey in runs) {
        const run = runs[runKey]

        if (!!run) {
            run.time = parseFloat(parseFloat(run.time).toFixed(2))
        }
    }
}

const matchRunToMorphokineticsEvent = well => {
    const { morphokinetics } = well.inferenceData

    const runKeys = Object.keys(well.runs)

    for (let mkIndex = -1; mkIndex < morphokinetics.length; mkIndex++) {
        const currentMkEvent = mkIndex >= 0 ? morphokinetics[mkIndex] : null

        const currentMkTime = currentMkEvent ? currentMkEvent.value : null

        const nextMkTime =
            mkIndex + 1 <= morphokinetics.length - 1 ? morphokinetics[mkIndex + 1].value : null

        for (const runKey of runKeys) {
            const run = well.runs[runKey]

            if (!!run) {
                const runTime = run.time

                if (
                    (currentMkTime == null || runTime >= currentMkTime) &&
                    (nextMkTime == null || runTime < nextMkTime)
                ) {
                    run.mkEvent = currentMkEvent
                }
            }
        }
    }
}

export default {
    prepareSlideCard(slideCard, instrument) {
        if (instrument && instrument.type === INSTRUMENT_TYPE.VITRO) {
            slideCard.esId = UIUtils.getVitrolifeSlideIdWithDescription(slideCard)
        }

        slideCard.instrument = instrument

        if (slideCard.bestWells) {
            slideCard.bestWells.forEach((well, idx) => this.extendWell(well, idx))
        }
    },

    extendInstruments(instruments) {
        instruments.forEach(instrument => {
            instrument.slides.forEach(slide => {
                if (slide) {
                    this.prepareSlideCard(slide, instrument)
                }
            })
            instrument.filteredSlides = []
        })
    },

    extendPatients(patients, user) {
        patients.forEach(patient => {
            this.preparePatient(patient, user.tenants)
        })
    },

    extendPastSlides(slideCards) {
        slideCards.forEach(slideCard => {
            this.prepareSlideCard(slideCard, {
                type: slideCard.instrumentType,
                esId: slideCard.instrumentEsId
            })
        })
    },

    preparePatient(patient, tenants) {
        patient.tenant = tenants.find(tenant => tenant._id === patient.tenantId)

        // todo: remove mock
        patient.fullName = patient.fullName ? patient.fullName.substring(0, 3) : ''
        patient.color = UIUtils.getPatientColor(patient.createdAt)
        patient.lastOpened = UIUtils.formatDate(new Date())
    },

    extendTreatment(treatment) {
        treatment.slides = treatment.instruments.flatMap(instrument => {
            return instrument.slides.map(slide => {
                if (instrument.type === INSTRUMENT_TYPE.VITRO) {
                    slide.esId = UIUtils.getVitrolifeSlideIdWithDescription(slide)
                }

                slide.videoFPS = 10
                slide.instrumentType = instrument.type
                return slide
            })
        })

        treatment.hoursSinceFertilization = treatment.slides.any().hoursSinceFertilization

        treatment.wellsByIndex = treatment.slides
            .flatMap(slide => slide.wells)
            .filter(well => !!well)

        treatment.wellsByIndex.forEach((well, idx) => this.extendWell(well, idx))
    },

    extendWell(well, treatmentIndex = null) {
        well.index = treatmentIndex

        if (!well.insemination) {
            well.insemination = {}
        }

        if (!well.runs) return

        calibrateTimings(well)
        matchRunToMorphokineticsEvent(well)

        // allowing to bind to notes change events
        well.notes = []

        // todo: remove mock
        well.inferenceData.blastInfo = BlastInfo
        well.inferenceData.gardnerScore = null

        well.mkEventsMap = {}

        for (const mkEventSN of ALL_MK_EVENTS) {
            well.mkEventsMap[mkEventSN] = well.inferenceData.morphokinetics.find(mkEvent => {
                return mkEvent.systemName.toLowerCase() === mkEventSN.toLowerCase()
            })
        }

        well.isBlast = well.mkEventsMap['tb'] && well.inferenceData.blastScore
    }
}
